<template>
    <div>
        <!-- special handling for png images with transparent bg -->
        <v-card v-if="section_id=='cloud'" class="elevation-0 transparent image-card-left">
            <v-img :ref="`ref${section_id}`" class="image" @click="viewImage" title="Click to zoom"></v-img>
        </v-card>

        <!-- special handling for horizontal orientation -->
        <v-img v-if="section_id!='cloud'&&image.orientation=='portrait'" :ref="`ref${section_id}`" class="image mx-auto portrait transparent" @click="viewImage" title="Click to zoom" contain></v-img>

        <!-- jpg images -->
        <v-card v-if="section_id!='cloud'&&image.orientation=='landscape'" :class="location=='left'?'elevation-20 image-card':'elevation-20 image-card-right'">
            <v-img :ref="`ref${section_id}`" class="image" @click="viewImage" title="Click to zoom"></v-img>
        </v-card>
        
        <v-dialog v-model="dialogPicViewer" fullscreen hide-overlay transition="dialog-bottom-transition">
            <image-viewer ref="picViewerRef" :image="image" :dialogPicViewer.sync="dialogPicViewer"></image-viewer>
        </v-dialog>
    </div>
</template>
<script>
export default {
    data() {
        return {
            dialogPicViewer: false,
        }
    },
    components: {
        'image-viewer': () => import('@/components/ImageViewer'),
    },
    methods: {
        viewImage() {
            this.$refs.picViewerRef.viewPic()
            this.dialogPicViewer = true
        },
        handleScroll (event) {    
            if (window.scrollY >= (this.section_pos-300)) {
                //lazy load images
                if (this.image.fileName) {
                    //note, converting image src value to data property causes rendering lag
                    //this code generates warning but render smoothly
                    this.$refs[`ref${this.section_id}`].src = require(`@/assets/landing/${this.image.fileName}`)
                }
            }
        }
    },
    props: ['image', 'location', 'section_id', 'section_pos'],
    computed: {
        isMobile() {
            return window.innerWidth < 600
        },
    },
    created() {
        window.addEventListener('scroll', this.handleScroll)
    },
    unmounted () {
      this.element.removeEventListener('scroll', this.handleScroll);
    },
}
</script>
<style lang="scss">
.image-card {
    margin:20px 20px 20px 30px;
    border-radius:5px;
}
.image-card-right {
    margin:20px 30px 20px 20px;
    border-radius:5px;
}
.portrait {
    height:420px;
    width:260px;
}
.portrait-mobile {
    height:420px;
    width:260px;
    margin: 10px 0px 10px 0px
}
.image {
    width:100%;
    margin-top:-30px;
    cursor:pointer;
}
.portrait {
    height:440px;
    width:260px;
    margin:0px 0px 10px 0px;
}
</style>